import { getAuthCookie, canReadWriteCookies } from './cookies';
import { getGraphQLClient } from '@simplywallst/services';

const getHeader = () => ({
  'apollographql-client-name': RUNTIME_ENV === 'native' ? 'mobile' : 'web',
});

export async function request<T>(query, variables = {}) {
  const client = getGraphQLClient({
    headers: getHeader(),
  });
  return await client.request<T>(query, variables);
}

export async function requestWithAuth<T>(query, variables = {}) {
  const client = getGraphQLClient({
    headers: getHeader(),
  });
  if (!canReadWriteCookies()) throw new Error('Cannot read cookies');
  const auth = await getAuthCookie();
  if (typeof auth === 'undefined') {
    throw new Error('Auth cookie is invalid');
  }
  client.setHeader('Authorization', `Bearer ${auth.accessToken}`);
  return await client.request<T>(query, variables);
}
